import { Col, Divider, Row } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import './style.scss'
import { useTranslation } from 'react-i18next'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import BusinessCardFilterBar from './feature/BusinessCardFilterBar'
import BusinessCardFooterBar from './feature/BusinessCardFooterBar'
import BusinessCardList from './entities/BusinessCardList'
import { orderFilterSchema } from './models/orderListFilter.schema'
import { tabsItems } from './constants/tabsItems.constant'
import {
  BusinessCardListRequest,
  useBusinessCardQhtStatusQuery,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'
import ContentBoxNew from '@shared/ContentBoxNew'

function BusinessCardOrder() {
  const { t } = useTranslation()

  const { isError, isFetching, isSuccess, error } =
    useBusinessCardQhtStatusQuery({ status: 'qht', page: 'list' })

  const methods = useForm<BusinessCardListRequest>({
    mode: 'all',
    resolver: yupResolver(orderFilterSchema),
    defaultValues: {
      searchText: '',
    },
  })

  const shouldRenderChildren = isSuccess && !isFetching && !isError

  return (
    <ContentBoxNew
      isError={isError}
      isLoading={isFetching}
      errorMessage={error?.data}
      title={t('businessCardOrders.businessCardOrders')}
      activeKey="item-1"
      items={tabsItems()}
      shouldRenderChildren={shouldRenderChildren}
    >
      <FormProvider {...methods}>
        <Row style={{ flexDirection: 'column', gap: 20 }}>
          <Col span={24} order={0}>
            <BusinessCardFilterBar />
          </Col>
          <Col span={24} order={2}>
            <BusinessCardFooterBar />
          </Col>
          <Col span={24}>
            <Divider type="horizontal" />
            <BusinessCardList />
          </Col>
        </Row>
      </FormProvider>
    </ContentBoxNew>
  )
}

const mapStateToProps = (state: any) => {
  return {
    leftMenuStatus: state.home.leftMenuStatus,
  }
}

export default connect(mapStateToProps, null)(BusinessCardOrder)
